export enum ProductType {
   Domain = 'domain',
   Cms = 'cms',
   M365 = 'm365',
   Bmp = 'bmp',
   Ssl = 'ssl',
   DomainPack = 'domain-pack'
}
